import { render, staticRenderFns } from "./jd.vue?vue&type=template&id=698909fa&scoped=true&"
import script from "./jd.vue?vue&type=script&lang=js&"
export * from "./jd.vue?vue&type=script&lang=js&"
import style0 from "./jd.vue?vue&type=style&index=0&id=698909fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698909fa",
  null
  
)

export default component.exports